import { Tooltip, Typography } from '@mui/material';
import { useRef } from 'react';

import { EntityPickerPopover } from '@work4all/components/lib/components/entity-picker/components';
import { OwnBankDetailsPicker } from '@work4all/components/lib/components/entity-picker/OwnBankDetailsPicker';

import { TenantBankAccount } from '@work4all/models/lib/Classes/TenantBankAccount.entity';

import { PickerTargetButton } from './PickerTargetButton';

export function OwnBankDetailsCell(props: {
  disabled?: boolean;
  value: TenantBankAccount;
  onChange: (value: TenantBankAccount | null) => void;
  label?: (value: TenantBankAccount | null) => React.ReactNode;
  className?: string;
  style?: React.CSSProperties;
  hover?: boolean;
  data?: TenantBankAccount;
  hideTooltip?: boolean;
  autoFocus?: boolean;
  alignValue?: 'right' | 'left';
}) {
  const {
    disabled = false,
    value,
    onChange,
    label,
    className,
    hover = false,
    style,
    data,
    hideTooltip,
    autoFocus,
    alignValue = 'left',
  } = props;

  const popoverRef = useRef<EntityPickerPopover>(null);

  const resultingLabel = label ? (
    <div style={{ color: 'var(--text01)', textAlign: alignValue }}>
      {label(value)}
    </div>
  ) : value ? (
    <>
      <Typography component="span" variant="body2" color={'var(--text01)'}>
        {value.name}
      </Typography>
      <Typography component="span" variant="body2" color="text.tertiary">
        {value.iban && value.name ? ' | ' : ''}
        {value.iban}
      </Typography>
    </>
  ) : null;

  return (
    <EntityPickerPopover
      ref={popoverRef}
      picker={
        <OwnBankDetailsPicker value={value} onChange={onChange} data={data} />
      }
    >
      <Tooltip title={hideTooltip ? '' : value?.name ?? ''}>
        <PickerTargetButton
          disabled={disabled}
          style={style}
          hover={hover}
          className={className}
          autoFocus={autoFocus}
          transparent
        >
          {resultingLabel}
        </PickerTargetButton>
      </Tooltip>
    </EntityPickerPopover>
  );
}
